// Use the server's stored deadline, never a fresh lifetime on view/share.
export function introDeadline(value) {
  if (typeof value !== 'string' ||
      !/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d{1,6})?(?:Z|[+-]\d{2}:\d{2})$/.test(value)) return null;
  const time = Date.parse(value);
  if (!Number.isFinite(time)) return null;
  // Date.parse rolls invalid calendar dates forward (e.g. February 30).
  const wall = value.slice(0, 19);
  const wallTime = Date.parse(`${wall}Z`);
  if (!Number.isFinite(wallTime) || new Date(wallTime).toISOString().slice(0, 19) !== wall) return null;
  return time;
}

export function introExpired(value, now = Date.now()) {
  const deadline = introDeadline(value);
  return deadline === null || now >= deadline;
}

export function introExpiryNotice(value, local = false, includeSaveReminder = true) {
  const deadline = introDeadline(value);
  if (deadline === null) return 'Expiry unavailable. Ask the sender for a new introduction.';
  const date = new Date(deadline);
  const label = local
    ? `${date.toLocaleDateString('en', { year: 'numeric', month: 'short', day: 'numeric' })} at ${
      date.toLocaleTimeString('en', { hour: 'numeric', minute: '2-digit', hour12: true, timeZoneName: 'short' })}`
    : `${date.toISOString().slice(0, 16).replace('T', ' ')} UTC`;
  return `These introduction links expire on ${label}.${includeSaveReminder ? ' Save the contact details before then.' : ''}`;
}
